var Curriculog = Curriculog || {};

Curriculog.ManageRolesBasicView = (function ($, _, Backbone, ManageRolesBasicView) {

    ManageRolesBasicView = Curriculog.ManageRolesView.extend({
        template: 'HierarchyFlyout/manageRolesBasic.html',
        events: {
            'change #role-type-dropdown': 'refreshCommitteeDropdown',
            'click #entity-role-update': 'basicRoleUpdate',
            'click #entity-role-delete': 'checkDeletedRoleImpact',
            'click #entity-role-cancel': 'render',
        },

        mask: function () {
            return '#manage-role-' + this.currentRoleID
        },

        initialize: function (options) {
            this.roles = options.roles;
            this.roleTypes = options.roleTypes;
            this.committees = options.committees;
            this.canDelete = options.canDelete;
            this.currentRoleID = options.currentRoleID;
            this.role = this.roles.get(this.currentRoleID);
            this.render();
        },

        render: function () {
            this.removeErrors();

            var roleTypeID = this.role.get('role_type_id');
            var roleType = this.roleTypes.get(roleTypeID);
            var committeeID = this.role.get('committee_id') || null;

            templateData = {
                role: this.role.toJSON(),
                roleTypeName: roleType.get('name'),
                canDelete: this.canDelete,
                roleID: this.currentRoleID
            }

            if (committeeID) {
                var committee = this.committees.get(committeeID);
                templateData['committeeName'] = committee.get('name');
            }

            var el = nunjucks.render(this.template, templateData);
            this.replaceElement(el);

            if (this.canDelete) {
                var entityID = this.role.get('entity_id');
                var disabledList = this.roles.getRoleTypeIDsForEntity(entityID);
                this.renderRoleTypeDropdown();
                this.refreshRoleTypeDropdown(disabledList);
                this.roleTypeDropdown.changeCurrentSelection(roleTypeID);

                this.renderCommitteeDropdown();
                if (committeeID) {
                    this.committeeDropdown.changeCurrentSelection(committeeID);
                } else {
                    this.refreshCommitteeDropdown();
                }

                this.$el.find('#entity-role-delete').prop('disabled', false);
            }
        },

        basicRoleUpdate: function () {
            var view = this;
            var roleValues = this.getBasicUpdatedRoleValues();
            if (roleValues['name'].trim().length > 0) {
                this.updateRole(roleValues, function () {
                    view.removeErrors();

                    if (view.canDelete) {
                        var entityID = view.role.get('entity_id');
                        var disabledList = view.roles.getRoleTypeIDsForEntity(entityID);
                        view.refreshRoleTypeDropdown(disabledList);
                        view.roleTypeDropdown.changeCurrentSelection(view.role.get('role_type_id'));
                    }
                });
            } else {
                this.showNameRequiredError()
            }

        },

        getBasicUpdatedRoleValues: function () {
            var newName = this.$el.find('#entity-role-name').val();

            roleValues = {};
            roleValues['id'] = parseInt(this.currentRoleID);
            roleValues['name'] = newName;

            if (this.canDelete) {
                var roleTypeID = this.roleTypeDropdown.getCurrentSelection();
                roleValues['role_type_id'] = parseInt(roleTypeID);
                var roleType = this.roleTypes.get(roleTypeID);
                roleValues['committee_id'] = null;

                if (roleType.get('committee') === 1) {
                    var committeeID = this.committeeDropdown.getCurrentSelection();

                    if (committeeID){
                        roleValues['committee_id'] = parseInt(committeeID);
                    }
                }
            }

            return roleValues;
        },

        checkDeletedRoleImpact: function () {
            var view = this;
            var roleModel = app.roles.get(this.currentRoleID);

            $.ajax({
                type: 'DELETE',
                url: 'rest/hierarchyroleimpact/' + roleModel.get('id'),

                error: function() {
                    var errorText = 'An error was encountered when deleting the role.  ';
                    errorText += 'The role has not been deleted.  Please try again '
                    errorText += 'or contact an administrator.';
                    view.showGrowl(errorText);
                },

                success: function (data) {
                    // only show the dialog if there are affected steps
                    if (data.num_current_steps + data.num_future_steps > 0) {
                        var templateData = view.generateDialogTemplateData(data, 'deleting');
                        var msg = nunjucks.render(view.impactDialogTemplate, templateData);
                    } else {
                        var msg = 'Are you sure you want to delete the ' + roleModel.get('name') + ' role?';
                    }

                    new Curriculog.SimpleConfirmDialog({
                        message: msg,
                        confirmCallback: function () {
                            this.close();
                            view.delete(roleModel);
                        },
                    });
                },
            });
        },
    });
    return ManageRolesBasicView;

})($, _, Backbone, Curriculog.ManageRolesBasicView || {});
